<template>
  <!-- <div
    ref="alert-box"
    :class="`cheetah-alert-box cheetah-alert-box__${type || 'information'}`"
  >
    <font-awesome-icon
      :icon="['fas', 'times']"
      @click="close"
    />
    <div  ref="alert-box" class="cheetah-alert-box__content">
      <font-awesome-icon
      v-if="with_icon"
      :icon="['fas', 'exclamation-triangle']"
      @click="close"
    />
      <slot name="content" />
    </div>
  </div> -->

  <div v-if="!closed" class='ba-require-alert ba-w-100' :class="`ba-${type || 'info'}`">
      <div class='ba-content'>
          <span>{{ $t(`ct-${type || 'info'}`) }}</span>
    
            <slot name="content" />

      </div>    
      <button class='ba-btn ba-sm' :class="`ba-${btnColor[type || 'info']}`" @click="close">{{ $t("ct-close") }}</button>
  </div>

  <!-- <div v-if="!closed" :class="[ `ba-${type || 'info'}`, with_icon ? 'ba-alert' : 'ba-top-alert' ]">
      <slot name="content" />
      <a class='ba-btn ba-btn-close ba-sm ba-rounded' @click="close">
        <builderall-icon code='64f7' />
      </a>
    </div> -->

</template>

<script>
export default {
  name: 'AlertBoxComponent',
  props: ['type', 'with_icon'],
  data() {
    return {
      closed: false,
      btnColor: {
        error: 'red',
        warning: 'orange',
        info: 'blue'
      }
    }
  },
  methods: {
    close() {
      // this.$refs['alert-box'].classList.add('cheetah-alert-box__close')
      // this.$refs['alert-box'].style.display = 'none'
      this.closed = true;

      // setTimeout(() => {
      // }, 300)
    }
  },
}
</script>

<style lang="scss" scoped>
.ba-require-alert:not(.ba-toast) {
  justify-content: space-between;
}
// .cheetah-alert-box {
//   position: relative;
//   border-radius: 5px;
//   padding: 20px 16px 20px 15px;
//   color: #080D3ACC;

//   transition: all 0.3s;

//   &__information {
//     background: #A6D3FE;
//     border-left: #0080FC 9px solid;
//   }

//   &__warning {
//     background: #F9EDAB;
//     border-left: #EFCD11 9px solid;

//     > div svg:first-child {
//       color: #FF6156;
//     }
//   }

//   &__danger {
//     background: #FABEAC;
//     border-left: #EF4411 9px solid;

//     > div svg:first-child {
//       color: #FF6156;
//     }
//   }

//   &__content {
//     display: flex;
//     align-items: center;

//     svg {
//       font-size: 20px;
//       margin-right: 12px;
//     }

//     span {
//       font-family: 'Lato', sans-serif;
//       font-size: 13px;
//     }
//   }

//   &__close {
//     visibility: hidden;
//     opacity: 0;
//   }


//   > svg {
//     position: absolute;
//     top: 0;
//     right: 0;

//     font-size: 10px;
//     color: #FFFFFF;

//     margin: 15px 15px 0px 0px;
//     cursor: pointer;
//   }
// }

// .alert-tag > .cheetah-alert-box {
//   &__content {
//     flex-direction: column;

//     span {
//       padding-top: 5px;
//       text-align: center;
//     }
//   }
// }

.ba-btn{
  border-radius: 10px;
  outline: none;
  border: none;
  cursor: pointer;
  font-weight: 600;
  text-transform: uppercase;
  transition: .4s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 9.6px;
  padding: 6.4px 12.8px;
  font-size: 12px;
  
  &:hover{
    text-decoration: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/commons/AlertBoxComponent.vue